import React, { useEffect, useMemo, useState } from "react";
import { ListProductUseCase } from "../../../Usecase/Products/list-product-usecase";
import { useToast } from "../../../Hooks/ToasContext";
import { IProductEntity } from "../../../Services/api/products/products.interface";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";


import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitHandler, useForm } from "react-hook-form";
import * as Yup from 'yup'
import { useNavigate, useParams } from "react-router-dom";
import { IArtEntity, ICreateArtPayload, IUpdateArtPayload } from "../../../Services/api/arts/arts.interface";

import { CreateArtsUseCase } from "../../../Usecase/Arts/create-arts-usecase";
import { ShowArtsUseCase } from "../../../Usecase/Arts/show-arts-usecase";
import {ICustomerEntity } from "../../../Services/api/customers/customers.interface";
import { IOptionsProps } from "../../../Components/Form/Select/select.component";

import { v4 as uuid } from 'uuid'
import { IAddressEntity } from "../../../Services/api/addresses/addresses.interface";
// import { UpdateArtsUseCase } from "../../../Usecase/Arts/update-arts-usecase";

interface IuseCreateOrdersSingleListProps {
    createArtsUseCase: CreateArtsUseCase
     showArtsUseCase: ShowArtsUseCase
    //  updateArtsUseCase: UpdateArtsUseCase
}

const CreateArtSchemaValidation = Yup.object().shape({
    charge_address: Yup.string().required('Endereço de cobrança é obrigatório'),
    delivery_address: Yup.string().required('Endereço de entrega é obrigatório'),
});


interface IArtProps {
	charge_address: string
  delivery_address: string
  [key: string]: string
}

interface IPaymentSingleOrder {
  id: string;
  type: 'card' | 'boleto' | 'pix' | undefined;
  card_brand?: string;
  installments: number;
  cod?: string;
  value: string;
}

export function useCreateOrdersSingleList({ createArtsUseCase, showArtsUseCase }: IuseCreateOrdersSingleListProps){
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<IArtEntity>()
    const [showCustomersModal, setShowCustomersModal] = useState(false)
    const [showProductsModal, setShowProductsModal] = useState(false)
    const [customerSelected, setCustomerSelected] = useState<ICustomerEntity>()
    const [productsSelected, setProducstSelected] = useState<IProductEntity[]>([])
    const [address, setAddress] = useState<IOptionsProps[]>([])
    const [payments, setPayments] = useState<IPaymentSingleOrder[]>([])

    const params = useParams()

    const typePayment = [
      {
        value: 'card',
        label: 'Cartão de Crédito'
      },
      {
        value: 'boleto',
        label: 'Boleto'
      },
      {
        value: 'pix',
        label: 'Pix'
      }
    ]

    const cardBrand = [
      {
        value: 'visa',
        label: 'Visa'
      },
      {
        value: 'mastercard',
        label: 'Mastercard'
      },
      {
        value: 'elo',
        label: 'Elo'
      },
      {
        value: 'amex',
        label: 'American Express'
      }
    ]
    
    const navigate = useNavigate()
    const { handleSubmit, register, control, formState, setValue, watch } = useForm<IArtProps>({
        resolver: yupResolver(CreateArtSchemaValidation),
      });

      const { errors } =  formState

    const { showToast } =  useToast()

    const listArts = async (boxId: string) => {
        
        try {
          setLoading(true)
          
          const showResult = await showArtsUseCase.handle(boxId);

          if (showResult.isFailure) {
            showToast(String(showResult?.error?.error), 'error');
            return;
          }

         const box = showResult.getValue()

         

        } catch (error) {
          console.log("error listArts function: ", error)
        } finally {
          setLoading(false);
        }
      };


    const handleAction: SubmitHandler<IArtProps> = async (values) => {
        console.log("values: ", values)
        try {
          setLoading(true)

          if(!productsSelected?.length){
            showToast('Selecione o Produto', 'error');
            setLoading(false)
            return;
          }

          if(!customerSelected?.id){
            showToast('Selecione o Cliente', 'error');
            setLoading(false)
            return;
          }

          // const payloadCreate: ICreateArtPayload  = {
          //   ...values,
          //   product_id: productSelected.id,
          //   customer_id: customerSelected.id,
          // }

          // const payloadUpdate: IUpdateArtPayload  = {
          //   ...values,
          //   product_id: productSelected.id,
          //   customer_id: customerSelected.id,
          //   id: String(params.id)
          // }

          // console.log("payloadUpdate: ", payloadUpdate)

        
          // // const storeResult = params.id ? await updateArtsUseCase.handle(payloadUpdate) :  await createArtsUseCase.handle(payloadCreate);
          // const storeResult =  await createArtsUseCase.handle(payloadCreate);

          // if (storeResult.isFailure) {
            
          //   showToast(String(storeResult?.error?.error), 'error');
          //   return;
          // }

          // showToast(params.id ? 'Caixa Atualizada' : 'Caixa Cadastrads', 'success')
          // navigate('/box-list');

        } catch (error) {
            console.log("error: ", error)
            showToast(error.response?.data?.error ?? 'Erro. Por favor, tente novamente', 'error');
          // toast({
          //   position: 'top-right',
          //   render: () => <ToastCustom type='fail' title='Erro' description={error.response?.data?.error ?? 'Erro ao logar. Por favor, tente novamente'} />,
          // });
        } finally {
          setLoading(false);
        }
      };

  
    useEffect(() => {
      if(params.id){
        listArts(params.id)
      }
    },[])

    const handleSelectCustomer = (customer: ICustomerEntity) => {
      setCustomerSelected(customer)
      setShowCustomersModal(false)
    }

    useEffect(() => {
      if(customerSelected?.id){
        const normalize = customerSelected?.addresses?.map((i: IAddressEntity) => {
          return {
            label: `${i?.name}, ${i?.number} - ${i?.province}`,
            value: `${i?.name}, ${i?.number} - ${i?.province}`
          }
        })
        setAddress(normalize)
      }
    }, [customerSelected])

    const handleSelectProduct = (product: IProductEntity) => {
      setProducstSelected(prev => [...prev, product])
      setShowProductsModal(false)
    }

    const handleAddNewPayment = () => {
      setPayments(prev => [...prev, {
        id: uuid(),
        type: undefined,
        installments: 1,
        value: '0.00'
      }])
    }
      

    return {
        loading,
        handleSubmit,
        handleAction,
        register,
        setShowCustomersModal,
        showCustomersModal,
        errors,
        data,
        setCustomerSelected,
        customerSelected,
        handleSelectCustomer,
        handleSelectProduct,
        setShowProductsModal,
        showProductsModal,
        productsSelected,
        control,
        address,
        handleAddNewPayment,
        payments,
        typePayment,
        cardBrand,
        watch
        
        
        
    }
}